import { render, staticRenderFns } from "./DetailsCounter.vue?vue&type=template&id=a2c33d9e&scoped=true&"
import script from "./DetailsCounter.vue?vue&type=script&lang=js&"
export * from "./DetailsCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c33d9e",
  null
  
)

export default component.exports